import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {BaseModalComponent} from '../components/base.modal.component';
import {ModalModule} from 'ngx-bootstrap';
import {FieldsListComponent} from '../components/fields-list.component';
import {TableComponent} from '../components/table.component';
import {FileUploaderComponent} from '../file-uploader/file-uploader.component';
import {ImageModalComponent} from '../components/image.modal.component';
import {MapModalComponent} from '../components/map.modal.component';
import {AgmCoreModule} from '@agm/core';
import {BrowserModule} from '@angular/platform-browser';
import {KeysValuePipe, MinutePipe, MomentDatePipe, TimePipe} from '../common/pipes';
import {ImageManagerSelectComponent} from '../dashboard/image-manager/image-manager.select.component';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {ColorPickerModule} from 'ngx-color-picker';

const DECLARATIONS = [
    TableComponent,
    ImageModalComponent,
    MapModalComponent,
    FieldsListComponent,
    ImageManagerSelectComponent,
    FileUploaderComponent,
    BaseModalComponent,
    KeysValuePipe,
    TimePipe,
    MinutePipe,
    MomentDatePipe,
];

@NgModule({
    imports: [
        BrowserModule,
        CommonModule,
        FormsModule,
        ModalModule.forRoot(),
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBC01nYn_X0t-uT04ixACVNDao7kCInDQs'
        }),
        BsDatepickerModule.forRoot(),
        ColorPickerModule,

    ],
    declarations: [
        DECLARATIONS
    ],
    exports: [
        DECLARATIONS
    ],
    providers: []
})
export class SharedModule {
}
